import { Navigate, useLocation } from 'react-router-dom';

/** Legacy `/app` URL → hotel dashboard (preserves query string e.g. Stripe return). */
export default function LegacyAppRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/dashboard${search}`} replace />;
}
